import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    campaign_highlights: [],
    dialog: false,
    campaign_highlight: {},
    artists: [],
    partners: [],
  },

  mutations: {
    setCampaignHighlights(state, payload) {
      state.campaign_highlights = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedCampaign(state, payload) {
      state.campaign_highlight = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setArtists(state, payload) {
      state.artists = payload
    },
    setPartners(state, payload) {
      state.partners = payload
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/campaign-highlight')
        .then(r => {
          commit('setCampaignHighlights', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch, state }, id) {
      axios.admin
        .put('cms/campaign-highlight/' + id, {
          artist_id: state.campaign_highlight.artist_id,
          partner_id: state.campaign_highlight.partner_id,
          campaign_views: state.campaign_highlight.campaign_views,
          channel_subscribers: state.campaign_highlight.channel_subscribers,
          country: state.campaign_highlight.country,
          genre: state.campaign_highlight.genre,
          image_url: state.campaign_highlight.image_url,
          link: state.campaign_highlight.link,
          link_name: state.campaign_highlight.link_name,
          name: state.campaign_highlight.name,
          quote: state.campaign_highlight.quote,
          subscriber_reach: state.campaign_highlight.subscriber_reach,
          track_title: state.campaign_highlight.track_title,
          track_used: state.campaign_highlight.track_used,
          type: state.campaign_highlight.type,
          video_placement: state.campaign_highlight.video_placement,
          video_views: state.campaign_highlight.video_views,
          audience_territories: state.campaign_highlight.audience_territories
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedCampaign', {})
          dispatch('read')
        })
    },
    delete({ dispatch }, id) {
      axios.admin.put('cms/campaign-highlight/delete/' + id).then(() => {
        dispatch('read')
      })
    },
    publish({ dispatch }, id) {
      axios.admin.put('cms/campaign-highlight/publish/' + id).then(() => {
        dispatch('read')
      })
    },
    unpublish({ dispatch }, id) {
      axios.admin.put('cms/campaign-highlight/unpublish/' + id).then(() => {
        dispatch('read')
      })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
        .post('cms/campaign-highlight', {
          artist_id: state.campaign_highlight.artist_id,
          partner_id: state.campaign_highlight.partner_id,
          campaign_views: state.campaign_highlight.campaign_views,
          channel_subscribers: state.campaign_highlight.channel_subscribers,
          country: state.campaign_highlight.country,
          genre: state.campaign_highlight.genre,
          image_url: state.campaign_highlight.image_url,
          link: state.campaign_highlight.link,
          link_name: state.campaign_highlight.link_name,
          name: state.campaign_highlight.name,
          quote: state.campaign_highlight.quote,
          subscriber_reach: state.campaign_highlight.subscriber_reach,
          track_title: state.campaign_highlight.track_title,
          track_used: state.campaign_highlight.track_used,
          type: state.campaign_highlight.type,
          video_placement: state.campaign_highlight.video_placement,
          video_views: state.campaign_highlight.video_views,
          audience_territories: state.campaign_highlight.audience_territories
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedCampaign', {})
          dispatch('read')
        })
    },
    getArtists({ commit }) {
      commit('setLoading', true)
      axios.front
        .get(`${process.env.VUE_APP_API_HOST}/artists`)
        .then(r => {
          commit('setArtists', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    getPartners({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get(`/get_campaign_partners`)
        .then(r => {
          commit('setPartners', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
